import { env } from "@diana/env-ui";
import { User } from "oidc-client-ts";
import { EdgeUser, EdgeUserType, LoginData } from "../types";
import { getEndpointConfiguration } from "./getEndpointConfiguration";

const endpoints = getEndpointConfiguration();

const getEdgeUserStorageKey = (): string => {
  const authority = endpoints.sec;
  const clientId = env("OAUTH_CLIENT_ID");

  return `edgeuser:${authority}:${clientId}`;
};

export function globalGetUser() {
  const clientId = env("OAUTH_CLIENT_ID");
  if (!clientId) {
    return null;
  }

  const authority = endpoints.sec;
  const oidcStorage = sessionStorage.getItem(`oidc.user:${authority}:${clientId}`);
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}

export function globalGetEdgeUser(): EdgeUser | null {
  const storageKey = getEdgeUserStorageKey();
  const storedEdgeUser = sessionStorage.getItem(storageKey);
  if (!storedEdgeUser) {
    return null;
  }

  return JSON.parse(storedEdgeUser) as EdgeUser | null;
}

export function globalSetEdgeUser(edgeUser: EdgeUser | null) {
  const storageKey = getEdgeUserStorageKey();

  if (!edgeUser) {
    sessionStorage.removeItem(storageKey);
  } else {
    const edgeUserJSON = JSON.stringify(edgeUser);
    sessionStorage.setItem(storageKey, edgeUserJSON);
  }
}

export function getUserTypeFromSearchQuery(searchQuery: string): EdgeUserType {
  const searchParams = new URLSearchParams(searchQuery);
  const str = searchParams.get("userType") ?? EdgeUserType.Customer;
  const userType = str as keyof typeof EdgeUserType;

  return EdgeUserType[userType];
}

export function getValueFromUrlSearchQuery(searchQuery: string, ...query: string[]): string | undefined {
  const searchParams = new URLSearchParams(searchQuery);
  for (const queryKey of query) {
    const queryVal = searchParams.get(queryKey);
    if (queryVal) {
      return queryVal;
    }
  }
}

export const getInitialLoginData = (searchQuery: string): Pick<LoginData, "workId" | "otp" | "returnUrl" | "userType"> => {  
  const userTypeFromBody = (globalThis as any).userType as
    | EdgeUserType
    | undefined;

  const userType = endpoints.isCloud
    ? EdgeUserType.Customer
    : userTypeFromBody ?? getUserTypeFromSearchQuery(searchQuery);

  const workId = getValueFromUrlSearchQuery(searchQuery, "workId");
  const otp = getValueFromUrlSearchQuery(searchQuery, "otp");
  const returnUrl = getValueFromUrlSearchQuery(searchQuery, "returnUrl", "ReturnUrl") ?? endpoints.defaultReturnUrl;

  return {
    workId,
    otp,
    returnUrl,
    userType
  };
}
